import tw, { styled } from 'twin.macro';

export const ScaleInputWrapper = styled.div`
  ${tw`flex items-center mt-7`}
  flex-wrap: wrap;

  &.col {
   ${tw`flex-col items-start`}
    gap: 15px;
  }
`;

export const ScaleLabelWrapper = styled.label`
  ${tw`font-normal text-sm text-grey-light opacity-70`};
  color: #777;
  font-size: 14px;
  font-family: Circular Std !important;

  &.notInBuilder {
    font-size: var(--formFontSize);
    text-transform: var(--formLabelTransform);
    font-family: var(--formFontType) !important;
    color: var(--formBodyLabelColor, var(--formTextColor));
  }

  &.col {
    ${tw`my-7`}
  }
`;

export const ScaleInputLabel = styled.label`
  ${tw`flex flex-col-reverse items-center justify-center`}

  &.col {
    ${tw`flex-row`}
  }

  > span {
    font-size: 10px;
    font-family: var(--formFontType, Circular Std) !important;
  }
`

export const ScaleInput = styled.input`
  ${tw`mx-3.5 w-4 h-4`};
  accent-color: black;
`;
